// This file is generated by a script and should not be modified directly.
const markdown: string = "- `null` si `identifiant.rncp` est `null`\n- `true` si le numéro de fiche `identifiant.rncp` est inférieur à `34,000`\n- `false` sinon\n"
export default markdown
